<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item mt-4">
        <div class="date-grid">
          <div class="date-search-container">
            <div class="row m-l-5 m-r-5">
              <div class="col-md-3 form-group">
                <label for="orderDateTimePicker">Loading Date and Time <span>*</span></label>
                <input type="datetime-local" v-model="orderDateTime" class="search-input" />
              </div>
              <div class="col-md-3 form-group">
                <label for="unloadingDateTimePicker">Unloading Date and Time <span>*</span></label>
                <input type="datetime-local" v-model="unloadingDateTime" class="search-input" />
              </div>
              <div class="col-md-3 form-group">
                <label for="distributor">Distributor <span>*</span></label>
                <select v-model="distributor" id="distributor" class="form-control" disabled>
                  <option v-for="distributor in distributors" :key="distributor.id" :value="distributor.id">
                    {{ distributor.distributor_name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 form-group">
                <label for="bridging">Bridging <span>*</span></label>
                <select v-model="bridging" id="bridging" class="search-input">
                  <option v-for="bridge in bridgings" :key="bridge.id" :value="bridge.id">{{ bridge.name }}</option>
                </select>
              </div>
            </div>

            <div class="row m-l-5 m-r-5">
              <div class="col-md-3 form-group">
                <label for="bridging">Bridging Type <span>*</span></label>
                <select v-model="britype" id="bridging" class="search-input">
                  <option disabled value="">Select Bridging Type</option>
                  <option v-for="britype in britypes" :key="britype.id" :value="britype.id">{{ britype.vehicle_type }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 form-group" v-if="(vehicle && vehicle !== '0') || bridging === 2">
                <label for="vehicle">Vehicle <span>*</span></label>
                <select v-model="vehicle" id="vehicle" class="search-input">
                  <option v-for="veh in vehicles" :key="veh.id" :value="veh.id">{{ veh.vehicle_no }}</option>
                </select>
              </div>

              <div class="col-md-3 form-group">
                <label for="plant">Plant <span>*</span></label>
                <select v-model="plant" id="plant" class="search-input">
                  <option v-for="plant in plants" :key="plant.id" :value="plant.id">{{ plant.name }}</option>
                </select>
              </div>
              <div class="col-md-3 form-group">
                <label for="destination">Destination <span>*</span></label>
                <textarea v-model="destination" id="destination" class="search-input" rows="1"
                  placeholder="Enter Destination"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

     <!-- added v-else by isindu | 2025/ 12/ 02 -->
      <div v-else class="row m-l-5 m-r-5">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="border-bottom-primary">
                <th scope="col">Item</th>
                <th scope="col">Quantity</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in formattedBootstrapList" :key="index">
                <td>{{ item.item_name }}</td>
                <td>
                  <input type="number" class="form-control quantity-input" v-model.number="item.qty" min="0"
                    placeholder="0" ref="quantityInputs" />
                </td>
                <td>
                  <i @click="deleteItem(index)" class="fa fa-trash action-icon" aria-hidden="true"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="remark-section p-3">
        <label for="remark">Remark:</label>
        <textarea v-model="remark" id="remark" class="form-control" ref="remarkTextarea" @input="adjustTextareaHeight"
          placeholder="Add your remarks here..."></textarea>
      </div>

      <div class="d-flex justify-content-end p-3">
        <button type="button" class="btn btn-success" @click="issueGatePass" :disabled="!isFormValid || loading2">
          <span v-if="loading2" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-else>Update</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import {
  fetchPurchaseOrderDetails,
  updatePurchaseOrder,
  fetchVehicleListOrderRequest,
  fetchPlantOrderRequest,
  fetchBridgingList,
  fetchItemNameListOrderEditAllItem, fetchVehicleType
} from '@/services/dataService';
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      profile_id: localStorage.getItem('profile_id') || null,
      token: localStorage.getItem('token_set') || '',
      orderDateTime: '',
      unloadingDateTime: '',
      loading: false,
      loading2: false,
      bootstraplist: [],
      distributor: '',
      vehicle: '',
      plant: '',
      destination: '',
      bridging: '',
      britype: '',
      remark: '',
      distributors: [],
      vehicles: [],
      plants: [],
      bridgings: [],
      britypes: [],
      errors: {},
    };
  },

  setup() {
    const router = useRouter();
    const navigateToNewDispatch = () => {
      router.push('/new-dispatch');
    };
    return { navigateToNewDispatch };
  },

  computed: {
    formattedBootstrapList() {
      return this.bootstraplist.map(item => ({
        ...item,
        item_name: item.item_name,
        item_id: item.id || '',
        qty: parseInt(item.qty) || 0,
        cost: item.cost || 0,
        current_stock: item.current_stock || 0
      }));
    },

    isFormValid() {
      return (
        this.orderDateTime &&
        this.unloadingDateTime &&
        this.distributor &&
        this.bridging &&
        this.britype &&
        this.plant &&
        this.destination
      );
    }
  },

  methods: {
    adjustTextareaHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.remarkTextarea;
        textarea.style.height = "auto"; // Reset height to recalculate
        textarea.style.height = `${textarea.scrollHeight}px`; // Set to scrollHeight
      });
    },

    formatDateTimeLocal(datetimeLocal) {
      if (!datetimeLocal) return null;
      const date = new Date(datetimeLocal);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const milliseconds = "000"; // Set milliseconds as zero
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    },

    async loadPurchaseOrderDetails(id) {
      // added by isindu | 2025/ 12/ 02
      this.loading = true;

      try {
        // commented by isindu | 2025/ 12/ 02
        // this.loading = true;
        const response = await fetchPurchaseOrderDetails(id, this.token);
        const data = response.data.data.purchase_order;
        const details = response.data.data.purchase_order_details;

        this.orderDateTime = data.loading_date_time;
        this.unloadingDateTime = data.unload_date_time;
        this.distributor = data.distributor_id;
        this.vehicle = data.vehicle_no; // Set vehicle to vehicle_no
        this.plant = data.gas_plant_id;
        this.destination = data.distributor_location;
        this.bridging = data.bridging_id;
        this.britype = data.vehicle_type;
        this.remark = data.remarks;

        this.distributors = [{ id: data.distributor_id, distributor_name: data.distributor_name }];
        this.vehicles = [{ id: data.vehicle_no, vehicle_no: data.vehicle_no }];
        this.plants = [{ id: data.gas_plant_id, name: data.gas_plant_name }];
        this.bridgings = [{ id: data.bridging_id, name: data.bridging_name }];
        this.britypes = [{ id: data.vehicle_type, name: data.vehicle_type_name }];

        // console.log(this.vehicles);
        const companyId = localStorage.getItem('company_id');
        const isparent = 1;

        const itemsResponse = await fetchItemNameListOrderEditAllItem(companyId, isparent, this.token);
        const items = itemsResponse.data.data;

        this.bootstraplist = items.map(item => {
          const detail = details.find(d => d.item_id === item.id);
          return {
            ...item,
            qty: detail ? detail.qty : 0
          };
        });

        // commented by isindu | 2025/ 12/ 02
        // this.loading = false;
      } catch (error) {
        console.error("Failed to load purchase order details:", error);
        // this.loading = false;
      } finally {
        this.loading = false;
      }
    },

    async fetchVehicle() {
      try {
        const response = await fetchVehicleListOrderRequest(this.profile_id, this.token);
        if (response.data.status === "success") {
          this.vehicles = response.data.data;

          const vehicleFromOrder = this.vehicles.find(vehicle => vehicle.vehicle_no === this.vehicle);
          if (!vehicleFromOrder) {
            this.vehicles.push({ id: this.vehicle, vehicle_no: this.vehicle });
          }
        } else {
          this.errors.vehicles = response.data.message;
        }
      } catch (error) {
        this.errors.vehicles = "Failed to fetch vehicles.";
      }
    },

    async fetchPlant() {
      try {
        const response = await fetchPlantOrderRequest(this.token);
        if (response.data.status === "success") {
          this.plants = response.data.data;
        } else {
          this.errors.plants = response.data.message;
        }
      } catch (error) {
        this.errors.plants = "Failed to fetch plants.";
      }
    },

    async fetchVehicleTypes() {
      try {
        const response = await fetchVehicleType(this.token);
        if (response.data.status === "success") {
          this.britypes = response.data.data;
        } else {
          this.errors.britypes = response.data.message;
        }
      } catch (error) {
        this.errors.britypes = "Failed to fetch vehicle types.";
      }
    },

    async fetchBridgings() {
      try {
        const response = await fetchBridgingList(this.token);
        if (response.data.status === "success") {
          this.bridgings = response.data.data;
        } else {
          this.errors.bridgings = response.data.message;
        }
      } catch (error) {
        this.errors.bridgings = "Failed to fetch bridgings.";
      }
    },

    deleteItem(index) {
      this.bootstraplist[index].qty = 0; // Update the quantity in the bootstraplist array
      this.$refs.quantityInputs[index].value = 0; // Update the input field (optional, as v-model should handle this)
    },

    checkItemQuantities() {
      for (let i = 0; i < this.formattedBootstrapList.length; i++) {
        const quantity = this.$refs.quantityInputs[i] ? this.$refs.quantityInputs[i].value : '';
        if (quantity && quantity > 0) {
          // If any item has a non-empty, valid quantity, return true
          return true;
        }
      }
      // If no item has a valid quantity
      return false;
    },

    async issueGatePass() {
      if (!this.checkItemQuantities()) {
        const toast = useToast();
        toast.error('Please add at least one item.');

      } else {
        this.loading2 = true;  // Set loading to true when request starts
        const toast = useToast();

        const formattedLoadingDateTime = this.formatDateTimeLocal(
          this.orderDateTime
        );
        const formattedUnloadingDateTime = this.formatDateTimeLocal(
          this.unloadingDateTime
        );

        const payload = {
          distributor_id: this.distributor,
          loading_date_time: formattedLoadingDateTime,
          unload_date_time: formattedUnloadingDateTime,
          bridging_id: this.bridging,
          vehicle_type: this.britype,
          vehicle_no: String(this.vehicle),
          gas_plant_id: this.plant,
          distributor_location: this.destination,
          remarks: this.remark,
          profile_name: localStorage.getItem('profile_name') || '',
          is_active: 1,
          details: this.formattedBootstrapList
            .filter(item => item.qty > 0) // Filter out items with quantity 0
            .map(item => ({
              item_id: item.item_id,
              qty: item.qty,
              cost: item.cost,
              current_stock: item.current_stock
            }))
        };

        try {
          const response = await updatePurchaseOrder(this.$route.params.id, payload, this.token);
          if (response.data.status === "success") {
            toast.success("Purchase order updated successfully!");
            this.$router.push('/order-request-schedule');
          } else {
            toast.success(response.data.message);
            this.$router.push('/order-request-schedule');
          }
        } catch (error) {
          toast.error("Failed to update purchase order.");
        } finally {
          this.loading2 = false; // Reset loading state after the request
        }
      }
    }
  },

  mounted() {
    const orderId = this.$route.params.id;
    this.loadPurchaseOrderDetails(orderId);
    this.fetchVehicle();
    this.fetchVehicleTypes();
    this.fetchPlant();
    this.fetchBridgings();
    // this.fetchItems();
  }
};
</script>

<style scoped>
.quantity-input {
  width: 100px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
}

select {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.table td {
  background-color: #ffffff;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  list-style: none;
  padding: 0;
}

.popup-content li {
  margin-bottom: 10px;
}

.popup-content hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

.table td i {
  margin-right: 8px;
  color: red;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.remark-section {
  margin-top: 20px;
}

.remark-section label {
  font-weight: bold;
  font-size: 14px;
}

.remark-section textarea {
  width: 100%;
  height: 80px;
  /* Set a fixed height for all input fields */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.remark-section textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

/* Common styles for all input fields */
.search-input,
input[type="datetime-local"],
select,
textarea {
  width: 100%;
  /* Ensure all inputs take full width of their parent */
  height: 40px;
  /* Set a fixed height for all input fields */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}


/* added by isindu | 2025/ 12/ 02 */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}


#destination {
  resize: none;
  overflow: hidden;
}



</style>